export default __webpack_public_path__ + "static/media/JASPE MOOKAITA.113cb194.jpg";